import { render } from "./LeaveSetting.vue?vue&type=template&id=1549ecd8"
import script from "./LeaveSetting.vue?vue&type=script&lang=js"
export * from "./LeaveSetting.vue?vue&type=script&lang=js"

import "./LeaveSetting.vue?vue&type=style&index=0&id=1549ecd8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__